{
  "MaxfilterlistlimitLabel": "Limite máximo da lista de filtros:",
  "MaxreportrowdisplimitLabel": "Limite máximo de exibição da linha do relatório:",
  "MaxfilterlistlimitPlaceholder": "150",
  "MaxreportrowdisplimitPlaceholder": "150",
  "ContentRestriction_SectionHeader": "Restrição de conteúdo",
  "ContentRestriction_SectionPara": "Para ambientes com um grande número de dispositivos e\/ou agentes ACD, você pode aumentar o número máximo de",
  "NAME": "ContentRestriction"
}